var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrangeD = function SvgOrangeD(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221,
    height: 311,
    viewBox: "0 0 221 311",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8400"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M263.778 26.294c-62.613 35.078-47.83 72.102-182.342 130.332-131.674 57.002-95.51 180.342 49.898 216.213 101.967 25.154 171.052 143.575 291.688 91.472 166.857-72.068 49.566-193.886 67.18-325.042C501.444 55.563 438.434.176 359.17.17c-30.494-.002-63.383 8.192-95.392 26.124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "46.856%",
    x2: "73.891%",
    y1: "50%",
    y2: "25.056%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8400"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9,
    transform: "translate(-293 -167)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M348.53.499c-38.786 34.835-62.738 82.767-62.738 135.679 0 106.474 96.997 192.787 216.65 192.787 3.563 0 7.106-.076 10.628-.228-5.298-57.02-31.927-122.009-22.868-189.468C501.444 55.563 438.434.176 359.17.17c-3.517 0-7.065.108-10.64.329",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M9.663 215.508c-31.745 59.345 16.253 131.325 121.671 157.331 59.914 14.78 108.497 61.77 162.835 87.438 8.387-20.544 12.964-42.721 12.964-65.843 0-106.473-96.998-192.787-216.65-192.787-28.57 0-55.846 4.92-80.82 13.861",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrangeD);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/orange-d.d2ab516b60b962a6f5daa830d295d0a8.svg";